const defaultLogos = {
  connoisseur: 'VisualConnoisseur',
  expert: 'VisualExpert',
  ambassador: 'VisualAmbassador'
}

export function getVisualComponent(tierLogos) {
  const logos = {...defaultLogos, ...tierLogos}

  const logoImport = function (name) {
    return async function () {
      const pkg = await import(`../SvgChunk/${name}.svelte`);
      return pkg.default
    }
  }

  return {
    Connoisseur: logoImport(logos.connoisseur),
    Expert: logoImport(logos.expert),
    Ambassador: logoImport(logos.ambassador),
  }
}
